import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Switch, Route, Redirect } from "react-router";
import SessionsPage from "./pages/SessionsPage";
import MembershipPage from "./pages/MembershipPage";
import RegistrationInfoPage from "./pages/RegistrationInfoPage";
import CheckoutPage from "./pages/CheckoutPage";
import RegistrationCompletePage from "./pages/RegistrationCompletePage";
import RegistrationClosedPage from "./pages/RegistrationClosedPage";
import RegistrationNotAllowedPage from "./pages/RegistrationNotAllowedPage";
import RegistrationNotAvailablePage from "./pages/RegistrationNotAvailablePage";
import MembershipTypePage from "./pages/MembershipTypePage";
import ImpersonatePage from "./pages/ImpersonatePage";
import SchedulePage from "./pages/SchedulePage";
import ConferenceInfoPage from "./pages/ConferenceInfoPage";
import SessionPage from "./pages/SessionPage";
import ErrorPage from "./pages/ErrorPage";
import withTracker from "../withTracker";
import { waitlistUrl } from "../config";
import { relatedEventUrl } from "../config";

class Router extends Component {
  static propTypes = {
    me: PropTypes.object.isRequired,
  };

  componentDidMount() {}

  _routeUser = () => {
    let { me } = this.props;

    console.log("me.event.conferenceRegistrationOpen: " + me.event.conferenceRegistrationOpen);
    console.log("me.event.isImpersonating: " + me.event.isImpersonating);
    console.log("me.isRegistrationAllowed: " + me.isRegistrationAllowed);
    console.log("me.isRegistrationAvailable: " + me.isRegistrationAvailable);
    console.log("me.isRegistrationAvailableReason: " + me.isRegistrationAvailableReason);    
    console.log("me.event.quickCheckout: " + me.event.quickCheckout);
    console.log("me.event.sessionSelection: " + me.event.sessionSelection);
    console.log("me.event.registrationVisible: " + me.event.registrationVisible);
    console.log("me.event.allowRegistration: " + me.event.allowRegistration);
    console.log("me.isRegistered: " + me.isRegistered);

    if (!me.event.conferenceRegistrationOpen && !me.event.isImpersonating) {
      return <Redirect to="/registration-closed" />;
    } else if (!me.isRegistrationAllowed) {
      return <Redirect to="/registration-not-allowed" />;
    } else if (!me.isRegistrationAvailable) {
        if (me.isRegistrationAvailableReason === "RegisteredForRelatedEvent") {
          return <Redirect to="/related-event" />;
        }
        else if (me.isRegistrationAvailableReason === "ExceededMaxAttendees") {
          return <Redirect to="/registration-full" />;
        }
        else {
          return <Redirect to="/registration-not-available" />;
        }
    } else if (
      (!me.event.quickCheckout && !me.event.sessionSelection) ||
      !me.event.registrationVisible ||
      !me.event.allowRegistration
    ) {
      return <Redirect to="/conference-info" />;
    } else if (me.isRegistered) {
      return <Redirect to="/attendee-info" />;
    } else {
      return <Redirect to="/registration-info" />;
    }
  };

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route
            path="/registration-info"
            component={withTracker(RegistrationInfoPage)}
          />
          <Route path="/membership" component={withTracker(MembershipPage)} />
          <Route path="/sessions" component={withTracker(SessionsPage)} />
          <Route path="/checkout" component={withTracker(CheckoutPage)} />
          <Route
            path="/attendee-info"
            component={withTracker(RegistrationCompletePage)}
          />
          <Route
            path="/registration-complete"
            component={withTracker(RegistrationCompletePage)}
          />
          <Route
            path="/membership-type"
            component={withTracker(MembershipTypePage)}
          />
          <Route path="/schedule" component={withTracker(SchedulePage)} />
          <Route
            path="/conference-info"
            component={withTracker(ConferenceInfoPage)}
          />
          <Route
            path="/registration-not-allowed"
            component={withTracker(RegistrationNotAllowedPage)}
          />
          <Route
            path="/registration-closed"
            component={withTracker(RegistrationClosedPage)}
          />
          <Route
            path="/registration-not-available"
            component={withTracker(RegistrationNotAvailablePage)}
          />
          <Route
            exact
            path="/related-event"
            component={() => {
              window.location = relatedEventUrl;
              return null;
            }}
          />
          <Route
            exact
            path="/registration-full"
            component={() => {
              window.location = waitlistUrl + this.props.eventId;
              return null;
            }}
          />
          <Route path="/session/:id/:fromMobile?" component={withTracker(SessionPage)} />
          <Route
            path="/impersonate"
            render={() =>
              this.props.me.isStaff ? <ImpersonatePage /> : <Redirect to="/" />
            }
          />
          <Route path="/error" component={withTracker(ErrorPage)} />
          <Route render={this._routeUser} />
        </Switch>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    me: state.account.me,
    eventId: state.account.me.event.eventId,
  };
};

export default connect(mapStateToProps, null)(Router);
